/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AffiliateOutcome } from "./AffiliateOutcome";
import type { AffiliationStatusResponse } from "./AffiliationStatusResponse";

/**
 * Response from POST /affiliate. Always returns the post-call outcome and
 * the user's complete affiliation state so FE consumers can drive UI directly
 * off the response without a follow-up status fetch.
 *
 * ``newly_affiliated_partner_uids`` lists the partner uids that were claimed
 * or registered in this specific call. Populated only on ``newly_created``;
 * callers use it to brand the welcome screen against the partner that was
 * actually just claimed (which may differ from the user's stored
 * ``partner_intent`` — e.g. broad-match claims a membership partner the user
 * didn't explicitly intend).
 */
export interface AffiliateResponse {
  outcome: AffiliateOutcome;
  status: AffiliationStatusResponse;
  newly_affiliated_partner_uids?: string[];
}
